import { ArrowUpRight } from "lucide-react";
import { GALLERY } from "../data/products";
import { useLang } from "../i18n";
import { FadeIn, MaskLine, Micro } from "./Reveal";

const SPANS = [
  "md:col-span-7 aspect-[16/10]",
  "md:col-span-5 aspect-[4/3]",
  "md:col-span-5 aspect-[4/3]",
  "md:col-span-7 aspect-[16/10]",
];

export default function Projects() {
  const { t } = useLang();
  const items = t("projects.items");
  return (
    <section id="projects" data-testid="projects-section" className="scroll-mt-24 px-5 md:px-12 py-24 md:py-36 border-t border-white/5">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
        <div>
          <FadeIn>
            <Micro className="text-gold/80">{t("projects.chapter")}</Micro>
          </FadeIn>
          <h2 className="font-display uppercase leading-[0.95] text-[clamp(2rem,5vw,4rem)] mt-5">
            <MaskLine delay={0.05}>{t("projects.h1a")}</MaskLine>
            <MaskLine delay={0.15} innerClass="text-outline">{t("projects.h1b")}</MaskLine>
          </h2>
        </div>
        <FadeIn delay={0.2}>
          <p className="text-sm md:text-base text-cream/50 max-w-xs">
            {t("projects.p")}
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 [grid-flow-dense]">
        {GALLERY.map((g, i) => (
          <FadeIn key={g.img + i} delay={(i % 2) * 0.1} className={`relative ${SPANS[i]}`}>
            <figure
              data-testid={`project-${i}`}
              data-cursor="view"
              className="group absolute inset-0 overflow-hidden border border-white/10 bg-coal hover:border-gold/40 transition-colors duration-500"
            >
              <img
                src={g.img}
                alt={items[i]?.title || g.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-70 transition duration-700 ease-out group-hover:scale-[1.06] group-hover:opacity-95"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 flex items-end justify-between gap-4">
                <div>
                  <div className="text-[9px] tracking-[0.3em] uppercase text-gold/90">{items[i]?.tag || g.tag}</div>
                  <div className="font-display uppercase text-lg md:text-2xl mt-1.5 transition-transform duration-500 group-hover:-translate-y-0.5">
                    {items[i]?.title || g.title}
                  </div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-cream/30 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500 shrink-0" />
              </figcaption>
              <span className="absolute bottom-0 left-0 h-[2px] w-full bg-gold scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </figure>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
